// import $ from 'jquery';
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";
import moment from "moment";

class BarcodeReport extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        if (!Context.IsLogged()) {
            return;
        }

        this.state = {
            barcode: "",
            report: null,
        };

        this.Search = this.Search.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rbarcodesreport") ?
        (

            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("barcodereport")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.barcode}
                                onChange={(e) => this.setState({ barcode: e.target.value })}
                            ></input>
                        </div>
                        <div className="col-md-6">
                            <button className="btn btn-primary" onClick={this.Search}>
                                {Translation.Trans("search")}
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        {this.state.report && (
                            <div className="col-md-12">
                                <table className="table table-striped">
                                    <tr>
                                        <td>{Translation.Trans("sortdate")}</td>
                                        <td>
                                            {this.state.report.log_data.sort_dt &&
                                                moment(this.state.report.log_data.sort_dt).format(
                                                    "DD.MM.YYYY"
                                                )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("operator")}</td>
                                        <td>{this.state.report.log_data.user}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("sorter")}</td>
                                        <td>{this.state.report.log_data.sorter}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("quantity")}</td>
                                        <td>{this.state.report.log_data.qty}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("in_code")}</td>
                                        <td>{this.state.report.log_data.in_code}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("in_name")}</td>
                                        <td>{this.state.report.log_data.in_name}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("out_code")}</td>
                                        <td>{this.state.report.log_data.out_code}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("out_name")}</td>
                                        <td>{this.state.report.log_data.out_name}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("barcode_dt")}</td>
                                        <td>
                                            {this.state.report.log_data.barcode_dt &&
                                                moment(this.state.report.log_data.barcode_dt).format(
                                                    "DD.MM.YYYY"
                                                )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("checksum")}</td>
                                        <td>{this.state.report.log_data.checksum}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <hr></hr>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("sell_dt")}</td>
                                        <td>
                                            {this.state.report.packing_list_data.sell_dt &&
                                                moment(this.state.report.packing_list_data.sell_dt).format(
                                                    "DD.MM.YYYY"
                                                )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("invoice_date")}</td>
                                        <td>
                                            {this.state.report.packing_list_data.invoice_date &&
                                                moment(
                                                    this.state.report.packing_list_data.invoice_date
                                                ).format("DD.MM.YYYY")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("partner")}</td>
                                        <td>{this.state.report.packing_list_data.partner}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("hs")}</td>
                                        <td>{this.state.report.packing_list_data.hs}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("container_no")}</td>
                                        <td>{this.state.report.packing_list_data.container_no}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("truck_reg_no")}</td>
                                        <td>{this.state.report.packing_list_data.truck_reg_no}</td>
                                    </tr>
                                    <tr>
                                        <td>{Translation.Trans("trailer_reg_no")}</td>
                                        <td>{this.state.report.packing_list_data.trailer_reg_no}</td>
                                    </tr>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        ): (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    Search() {
        let sid = Context.GetContext().Sid;

        let report = Comm.CallServerFunction("report/barcode_with_packing_list_data", {
            session: sid,
            log_id: this.state.barcode,
        });
        this.setState({ report: report.result });
    }
}

export default BarcodeReport;



// WEBPACK FOOTER //
// ./src/pages/barcodereport.js